import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/HomeEnhanced';
import Contact from './pages/Contact';
import ProjectDetail from './pages/ProjectDetail';
import ComingSoon from './pages/ComingSoon';
import DemoProjects from './pages/DemoProjects';
import LiveVoiceDemo from './pages/LiveVoiceDemo';
import './App.css';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Header />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<Home />} />
          <Route path="/writing" element={<ComingSoon />} />
          <Route path="/demos" element={<DemoProjects />} />
          <Route path="/demos/live-voice-transcription-insight-engine" element={<LiveVoiceDemo />} />
          <Route path="/journal" element={<DemoProjects />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/work/:slug" element={<ProjectDetail />} />
        </Routes>
        <Footer />
      </BrowserRouter>
    </div>
  );
}

export default App;
